





































// vendor
import { defineComponent, PropType, computed } from "@vue/composition-api";
// local
import { ReorderableList } from "@/components.generic/reorderable-list";
import { LinearScale } from "../../ts/types/ItemSettings";

export default defineComponent({
	components:{
		ReorderableList
	},
	props:{
		data:{
			type:Object as PropType<LinearScale>,
			required:true
		}
	},
	setup(props, context){

		const columns = computed(() => props.data.columns);
		const rows = computed(() => props.data.rows);
		const labelPlaceholder = computed(() => "Ex. How are you feeling?");

		const getColumnPlaceholder = (i:number) => i.toString();

		return {
			columns,
			rows,
			labelPlaceholder,
			getColumnPlaceholder
		};
	}
});

